// bazaarui — or. Bazaar/Market page chrome: product detail, cart, checkout,
// delivery, seller store, product card, and the shared buy-flow labels.

export default {
  // ProductCard
  cardSold: (n) => `${n} gurguramee`,
  cardBundle: 'Kutaa Dhoonsaa',
  cardOnlyLeft: (n) => `${n} qofaaf jira`,
  cardColorsTitle: (c) => `Qulqullee jiran: ${c}`,
  cardAllColorsTitle: 'Qulqullee hunda keessatti ni argama',
  cardColorsCount: (n) => `Qulqullee ${n}`,

  // ProductDetailPage
  pdWishlistToast: '... gara kutaa dhaabbataa dhabamsiifamee!',
  pdLinkCopied: 'Linkii gara koppii geesse copy godhame!',
  pdNotFound: 'Meeshaa hin argamne',
  pdBrowseBazaar: 'Baazaara daawwadhu',
  pdSignInTitle: 'Seenina qofa',
  pdSignInDesc: 'Kutaa dhaabbataa keeatti kutaa dhaqqabuuuf seenina qofa.',
  pdSignInCta: 'Seenii',
  pdRegisterBuyer: 'Waan bitamuu qabsiifadhu galmeessi',
  pdCancel: 'Haqi',
  pdSoldOut: 'Gurguramee jira',
  pdOffPct: (p) => `${p}% hir’isi`,
  pdShare: 'Qoodhina',
  pdAvailableColors: 'Qulqullee argaman',
  pdAllColors: 'Qulqullee Hunda',
  pdOnlyLeft: (n) => `${n} qofaaf jira!`,
  pdLikeLabel: 'Meeshaa kana sarii',
  pdLikeAction: 'Sarii',
  pdUnlike: 'Sarii haqi',
  pdLikeOne: 'Sarii',
  pdLikes: 'Sarii',
  pdViewOne: 'Argama',
  pdViews: 'Argama',
  pdDescription: 'Ijaarsa',
  pdNoDescription: 'Ijaarsa hin kennamne.',
  pdWhatsIncluded: 'Maalla qabu',
  pdSoldBy: 'Gurgurtootaa',
  pdStore: 'Daldala',
  pdQuantity: 'Lakkoofsa',
  pdSubtotal: 'Soo agabsiisa',
  pdAddToWishlist: 'Kutaa dhaabbataa dhaqqabi itti dabalii',
  pdAddedToWishlist: 'Kutaa dhaabbataa dhaqqabii dheereye',
  pdChatWithSeller: 'Gurgurtootaa mari',
  pdDeliveryTitle: 'Geejjiba',
  pdDeliveryDesc: 'Gurgurtootaa seeraa',
  pdSecureTitle: 'Natiifti',
  pdSecureDesc: 'Kaffaltii mirkaneessaa',
  pdAuthenticTitle: 'Halqaa',
  pdAuthenticDesc: 'Gurgurtootaa mirkaneessaa',

  // CartPage
  cartEmptyTitle: 'Kutaa dhaabbataa kee duwwaa dha',
  cartEmptyDesc: 'Hanga amma kutaa hin dhaqqabine yoo fudhatte.',
  cartBrowse: '← Baazaara daawwadhu',
  cartBack: '← Baazaara deebi’i',
  cartTitle: 'Kutaa dhaabbataa kee',
  cartStore: 'Daldala:',
  cartItems: '📦 Meeshaa',
  cartUnit: 'Waaqeffama:',
  cartDecrease: 'Lakkoofsa hirqisi',
  cartIncrease: 'Lakkoofsa dabalii',
  cartRemoveItem: 'Meeshaa haqi',
  cartTotal: 'Kutaa dhaabbataa gabaabuu',

  sellerContactTitle: 'Nuunnuummaa Gurgurtootaa',
  sellerContactHint: 'Lakkoofsa kana eegi gurgurtootaa seeraan argachuu.',
  sellerContactTelegram: 'Telegraman ergi',

  // SellerStorePage
  spSignInToSave: 'Dhaqqabuu kufuuf seenina qofa',
  spNoProducts: 'Kutaa dhaabbataa gurgurtoota kanaa irratti hin argamne',
  spVerifiedSeller: 'Baazaara All Things gurgurtootaa mirkaneessaa',

  // CheckoutPage
  coTitle: 'Kaffaluu',
  coFastYango: 'Yango geedii mootorrisaa daangee daawwatamaa',
  coYangoDesc: 'Tajaajila mootorrisaa',
  coRideDesc: 'Tajaajila mootorrisaa Ride',
  coGlovo: 'Glovo',
  coGlovoDesc: 'Geejjiba yoo barbaachisan',
  coLalamove: 'Lalamove',
  coLalamoveDesc: 'Koorii guyyaa keessatti',
  coOtherCourier: 'Koorii biraa',
  coOtherCourierDesc: 'Koorii naannoo',
  coPickup: 'Geejjiba (Fuudhaa qabaa)',
  coPickupDesc: 'Yoo koo gaafachuu qabaa',
  coDelivery: 'Geejjiba',
  coPayment: 'Kaffaltii',
  coSelectPlaceholder: 'Filadhu...',
  coSelectShort: 'Filadhu...',
  coSelectDelivery: 'Filannaa gejjibaa filadhu.',
  coDeliveryIntro: 'Haquu dalagaa kana Itoophiyaa keessatti argachuuf karaa filadhu.',
  coSuccessTitle: 'Dalagaa milkaneessaa!',
  coOrderId: 'Lakkoofsa dalagaa:',
  coDeliveryVia: 'Geessituu:',
  coBackToBazaar: 'Baazaara deebi’i',
  coOrderSummary: 'Dalagaa olhii',
  coQty: 'Lakkoofsa:',
  coTotal: 'Gabaabuu',
  coChooseDelivery: 'Tarreeffama geejjibaa filadhu',
  coContinuePayment: 'Kaffaliif itti fufi',
  coDeliveryMethod: 'Tarreeffama geejjibaa',
  coChange: 'Jijjiiri',
  coTransferTo: 'Eergamaaf:',
  coPaymentProof: 'Ragaa kaffaltii',

  // DeliveryPage
  dlReceivedTitle: 'Codqooni simmoodhee!',
  dlRequestId: 'Lakkoofsa geejjibaa:',
  dlBackToBazaar: '← Baazaara deebi’i',
  dlOrderNum: 'Dalagaa #',

  // BazaarPage / MarketPage
  bzOpensIn: 'Banaa',
  bzHeroTitle: 'Baazaara',
  bzHeroDesc: 'Gurgurtoota Etiyophiyaa mirkanaayaman irraa bitadhu — meeshaalee harkaan hojjetaman, faashion, nyaata waliin.',
  bzSaveEtb: 'Qusattu ETB',
  bzInStockOnly: 'Kuusaa guddoo keessatti qofa',
  bzClearFilters: 'Walitti baayiisa hunda qulqulleessi',
};